import { useContextController } from "context";
import { useMemo } from "react";
import en from "../config/localized/en.json";
import fr from "../config/localized/fr.json";

const useTranslation = () => {
  const [{ locale }] = useContextController();

  return useMemo(() => {
    let strings: { [key in string]: string } = locale === "en" ? en : fr;
    return strings;
  }, [locale]);
};

export default useTranslation;
